import { useEffect, useState } from "react";
import { getNoOfCorpOrg, getAllProductsCount } from "../../Api/ApiCalls";
import LoadingSpinner from "../../common/Loading";
import SmallLoadingSpinner from "../../common/SmallLoading";
import log from "../../core/log";
import { NavLink } from "react-router-dom";
import { BarChart } from "./BarChart";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [chartLoading, setChartLoading] = useState(true);
  const [deployedChartData, setDeployedChartData] = useState({
    chartData: [],
    highestCount: {},
  });
  const [expiredChartData, setExpiredChartData] = useState({
    chartData: [],
    highestCount: {},
  });
  const [countData, setCountData] = useState({
    corporation_count: 0,
    organization_count: 0,
    store_count: 0,
    active_product_count: 0,
    expired_product_count: 0,
  });

  const getDashboardDetials = async () => {
    try {
      const data = await getNoOfCorpOrg();
      if (data && Object.keys(data).length) {
        setCountData(data);
      }
      setLoading(false);
    } catch (err) {
      log("Error while fetching corporation and organization count", err);
      setLoading(false);
    }
  };

  const getBarChartData = async () => {
    try {
      const data = await getAllProductsCount();
      if (data.status && data.deployed.success) {
        setDeployedChartData(data.deployed);
      }
      if (data.status && data.expired.success) {
        setExpiredChartData(data.expired);
      }
      setChartLoading(false);
    } catch (err) {
      log("Error while fetching products count", err);
      setChartLoading(false);
    }
  };

  useEffect(() => {
    getDashboardDetials();
    getBarChartData();
  }, []);
  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="text-4xl text-[#96BF61] font-bold mb-6">
        {" "}
        Fit Fresh admin Dashboard{" "}
      </div>
      <div className="flex justify-center font-bold mb-8">
        <div className="w-1/2 flex mr-2 justify-center items-center font-bold">
          <NavLink
            className="w-full h-auto cursor-pointer hover-div border-[2px] p-5 relative w-full font-bold bg-white hover:border-[#134d85] hover:bg-[#134d85] hover:text-white transition duration-200 ease-in-out"
            to="/manage/corporation"
          >
            <div className="flex justify-center font-bold">
              <div className="text-gray-700 data-count">Corporation Count</div>
              <div className="pl-3 text-[#134d85] data-count">
                {countData?.corporation_count || 0}
              </div>
            </div>
          </NavLink>
        </div>
        <div className="w-1/2 ml-2 flex justify-center items-center font-bold">
          <NavLink
            className="w-full h-auto cursor-pointer hover-div border-[2px] p-5 relative w-full font-bold  bg-white hover:border-[#134d85] hover:bg-[#134d85] hover:text-white transition duration-200 ease-in-out"
            to="/manage/organization"
          >
            <div className="flex justify-center font-bold">
              <div className="text-gray-700 data-count">Organization Count</div>
              <div className="pl-3 text-[#134d85] data-count">
                {countData?.organization_count || 0}
              </div>
            </div>
          </NavLink>
        </div>
      </div>
      <div className="flex justify-center font-bold mb-8">
        <div className="w-full flex justify-center items-center font-bold">
          <NavLink
            className="w-full h-auto cursor-pointer hover-div border-[2px] p-5 relative w-full font-bold bg-white hover:border-[#134d85] hover:bg-[#134d85] hover:text-white transition duration-200 ease-in-out"
            to="/dashboard/stores"
          >
            <div className="flex justify-center font-bold">
              <div className="text-gray-700 data-count">Location Count</div>
              <div className="pl-3 text-[#134d85] data-count">
                {countData?.store_count || 0}
              </div>
            </div>
          </NavLink>
        </div>
      </div>
      <div className="flex justify-center font-bold">
        <div className="w-1/2 flex mr-2 justify-center items-center font-bold">
          <NavLink
            className="w-full h-auto cursor-pointer hover-div border-[2px] p-5 relative w-full font-bold bg-white hover:border-[#134d85] hover:bg-[#134d85] hover:text-white transition duration-200 ease-in-out"
            to="/dashboard/products/active"
          >
            <div className="flex justify-center font-bold">
              <div className="text-gray-700 data-count">
                Active Product Count
              </div>
              <div className="pl-3 text-[#134d85] data-count">
                {countData?.active_product_count || 0}
              </div>
            </div>
          </NavLink>
        </div>
        <div className="w-1/2 ml-2 flex justify-center items-center font-bold">
          <NavLink
            className="w-full h-auto cursor-pointer hover-div border-[2px] p-5 relative w-full font-bold  bg-white hover:border-[#134d85] hover:bg-[#134d85] hover:text-white transition duration-200 ease-in-out"
            to="/dashboard/products/expired"
          >
            <div className="flex justify-center font-bold">
              <div className="text-gray-700 data-count">
                Expired Product Count
              </div>
              <div className="pl-3 text-[#134d85] data-count">
                {countData?.expired_product_count || 0}
              </div>
            </div>
          </NavLink>
        </div>
      </div>
      <div className="flex my-10">
        <div className="w-full">
          <h2 className="text-xl text-[#96BF61] font-bold mb-4">
            Product Deployment by Month
          </h2>
          {chartLoading ? (
            <div className="flex justify-center items-center bg-white border rounded-[7px] h-[343px] pl-10 pt-7 pb-5 pr-7 w-full">
              <div>
                <SmallLoadingSpinner
                  className={"w-16 h-16 border-[6px] opacity-60"}
                />
              </div>
            </div>
          ) : (
            <BarChart
              chartData={deployedChartData.chartData}
              highestCount={deployedChartData.highestCount}
              color={"bg-[#96BF61]"}
            />
          )}
        </div>
        <div className="p-2"></div>
        <div className="w-full">
          <h2 className="text-xl text-[#96BF61] font-bold mb-4">
            Expiring Product by Month
          </h2>
          {chartLoading ? (
            <div className="flex justify-center items-center bg-white border rounded-[7px] h-[343px] pl-10 pt-7 pb-5 pr-7 w-full">
              <div>
                <SmallLoadingSpinner
                  className={"w-16 h-16 border-[6px] opacity-60"}
                />
              </div>
            </div>
          ) : (
            <BarChart
              chartData={expiredChartData.chartData}
              highestCount={expiredChartData.highestCount}
              color={"bg-[#024C85]"}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
